import React, { useState, useEffect } from "react";
import { Row, Col } from "react-bootstrap";
import "./starRating.scss";
import ReactStars from "react-rating-stars-component";
import ModalCustom from "../Modal/ModalCustomDesign";
import Star from "../../../assets/star.svg";
import SelectedStar from "../../../assets/selectedStar.svg";

export default function StarRating(props) {
  const [starRating, setStarRating] = useState(props?.newRating);
  const [starRatingAudio, setStarRatingAudio] = useState(null);
  const [starRatingVideo, setStarRatingVideo] = useState(null);
  const [starRatingRx, setStarRatingRx] = useState(null);
  const [starRatingConsultation, setStarRatingConsultation] = useState(null);
  const [starRatingEaseOfBooking, setStarRatingEaseOfBooking] = useState(null);
  // const [starRatingFeatures, setStarRatingFeatures] = useState(null);
  const [feedback, setFeedback] = useState("");
  const [isActiveSubmit, setIsActiveSubmit] = useState(false);
  const [error, setError] = useState(false);
  const [limit, setLimit] = useState(255);
  const starRatingDesc = {
    1: "Very Poor",
    2: "Poor",
    3: "Average",
    4: "Good",
    5: "Excellent",
  };

  const ratingFeatures = [
    "Audio Quality",
    "Video Quality",
    "Rx Generation",
    "Consultation Joining",
  ];

  const ratingChanged = (newRating) => {
    setStarRating(newRating);
  };

  const ratingAudioQuality = (newRating) => {
    setStarRatingAudio(newRating);
  };

  const ratingVideoQuality = (newRating) => {
    setStarRatingVideo(newRating);
  };

  const ratingRxGenerationQuality = (newRating) => {
    setStarRatingRx(newRating);
  };

  const ratingConsultationJoingQuality = (newRating) => {
    setStarRatingConsultation(newRating);
  };

  const ratingEaseOfBookingQuality = (newRating) => {
    setStarRatingEaseOfBooking(newRating);
  };

  const handleTextChange = (e) => {
    const remaining = 255 - e.target.value.length;
    setLimit(remaining);

    if (e.target.value.length > 255) {
      e.target.value = e.target.value.substr(0, 255);
      setError(true);
    } else {
      setLimit(remaining);
      setError(false);
    }
    setFeedback(e.target.value);
  };
  return (
    <ModalCustom show={true} centered={true} className="custom-modal-design">
      <div id="star-rating-container-div" className="container">
        <div className="top_scroll">
          <div className="top_scroll_body">
            <div className="d-flex ai-center header-div">
              <div className="heading-title">Rate your experience</div>
              <div
                className="ml-auto close-conatiner"
                onClick={() =>
                  props.closeHandler(
                    starRating,
                    starRatingAudio,
                    starRatingVideo,
                    starRatingRx,
                    starRatingConsultation,
                    starRatingEaseOfBooking,
                    feedback
                  )
                }
              >
                Close
                <i className="fa fa-close pl-1" aria-hidden="true"></i>
              </div>
            </div>

            <Row className="m-0 body-div">
              <div className="w-100-imp">
                <div className="body-question">Overall Experience</div>
                <div className="star-rating-div">
                  {Object.keys(starRatingDesc).map((key) => {
                    return (
                      <div
                        className="star-detail"
                        key={key}
                        onClick={() => ratingChanged(key)}
                      >
                        <img src={starRating >= key ? SelectedStar : Star} />
                        <div
                          className={`rating-text ${
                            starRating === key ? "star-rating-value" : ""
                          }`}
                        >
                          {starRatingDesc[key]}
                        </div>
                      </div>
                    );
                  })}
                </div>
                {isActiveSubmit && !starRating && (
                  <span className="error-star">Please Select Rating</span>
                )}
                {starRating && (
                  <div className="rate_features_feedback_message">
                    <div className="rate_features_continer">
                      <div className="rate_features_heading">Rate Features</div>

                      {/* {ratingFeatures.map((featureName, index) => ( */}
                      <div className="rate_features_rating_container">
                        <div className="rate_features_rating_heading">
                          <p>Audio Quality</p>
                        </div>
                        <div className="star-rating-features-div">
                          {Object.keys(starRatingDesc).map((key) => {
                            return (
                              <div
                                className="star-detail"
                                key={key}
                                onClick={() => ratingAudioQuality(key)}
                              >
                                <img
                                  src={
                                    starRatingAudio >= key ? SelectedStar : Star
                                  }
                                />
                              </div>
                            );
                          })}
                        </div>
                      </div>
                      <div className="rate_features_rating_container">
                        <div className="rate_features_rating_heading">
                          <p>Video Quality</p>
                        </div>
                        <div className="star-rating-features-div">
                          {Object.keys(starRatingDesc).map((key) => {
                            return (
                              <div
                                className="star-detail"
                                key={key}
                                onClick={() => ratingVideoQuality(key)}
                              >
                                <img
                                  src={
                                    starRatingVideo >= key ? SelectedStar : Star
                                  }
                                />
                              </div>
                            );
                          })}
                        </div>
                      </div>
                      {props.provider_type === 1 ? (
                        <div className="rate_features_rating_container">
                          <div className="rate_features_rating_heading">
                            <p>Rx Generation</p>
                          </div>
                          <div className="star-rating-features-div">
                            {Object.keys(starRatingDesc).map((key) => {
                              return (
                                <div
                                  className="star-detail"
                                  key={key}
                                  onClick={() => ratingRxGenerationQuality(key)}
                                >
                                  <img
                                    src={
                                      starRatingRx >= key ? SelectedStar : Star
                                    }
                                  />
                                </div>
                              );
                            })}
                          </div>
                        </div>
                      ) : (
                        ""
                      )}
                      <div className="rate_features_rating_container">
                        <div className="rate_features_rating_heading">
                          <p>Consultation Joining</p>
                        </div>
                        <div className="star-rating-features-div">
                          {Object.keys(starRatingDesc).map((key) => {
                            return (
                              <div
                                className="star-detail"
                                key={key}
                                onClick={() =>
                                  ratingConsultationJoingQuality(key)
                                }
                              >
                                <img
                                  src={
                                    starRatingConsultation >= key
                                      ? SelectedStar
                                      : Star
                                  }
                                />
                              </div>
                            );
                          })}
                        </div>
                      </div>
                      {props.provider_type === 2 ? (
                        <div className="rate_features_rating_container">
                          <div className="rate_features_rating_heading">
                            <p>Ease of Booking and Payment</p>
                          </div>
                          <div className="star-rating-features-div">
                            {Object.keys(starRatingDesc).map((key) => {
                              return (
                                <div
                                  className="star-detail"
                                  key={key}
                                  onClick={() =>
                                    ratingEaseOfBookingQuality(key)
                                  }
                                >
                                  <img
                                    src={
                                      starRatingEaseOfBooking >= key
                                        ? SelectedStar
                                        : Star
                                    }
                                  />
                                </div>
                              );
                            })}
                          </div>
                        </div>
                      ) : (
                        ""
                      )}

                      {/* ))} */}
                    </div>
                    <div>
                      <div className="body-question">
                        Share more about your experience
                      </div>
                      <div>
                        <textarea
                          class="feedback_message new"
                          type="text"
                          placeholder="Feedback (optional)"
                          pattern="[a-zA-Z]{255}"
                          value={feedback}
                          onChange={(e) => handleTextChange(e)}
                          rows="3"
                        />
                        {error ? (
                          <small className="text-danger">
                            Characters left : 0 of 255
                          </small>
                        ) : (
                          <small
                            style={{
                              color: `${limit === 255 ? "#a3a9b7" : "#10A74A"}`,
                            }}
                          >
                            Characters left : {limit} of 255{" "}
                          </small>
                        )}
                      </div>
                    </div>
                  </div>
                )}
              </div>
            </Row>
          </div>
        </div>

        <div className="d-flex justify-content-center bottom_no_scroll">
          <button
            className={`${
              starRating ? "star-rating-button" : "star-rating-button disable"
            }`}
            onClick={() =>
              starRating
                ? props.successHandler(
                    starRating,
                    starRatingAudio,
                    starRatingVideo,
                    starRatingRx,
                    starRatingConsultation,
                    starRatingEaseOfBooking,
                    feedback
                  )
                : setIsActiveSubmit(true)
            }
          >
            Submit
          </button>
        </div>
      </div>
    </ModalCustom>
  );
}
